module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-info-box info-box",
    class: _vm.boxBgClass,
    style: (_vm.boxStyle)
  }, [_c('span', {
    staticClass: "info-box-icon",
    class: _vm.iconBgClass,
    style: (_vm.iconStyle)
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e28a72f2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info-box/info-box.vue
// module id = 10
// module chunks = 0